import React from 'react';
import NumberFormat from 'react-number-format';

function ParseNumberSmaller({ field, className, placeholder }: any) {
    return (
        <NumberFormat
            {...field}
            thousandSeparator={true}
            className={className || 'form-know-you-item-input-smaller display-flex'}
            decimalScale={0}
            allowNegative={false}
            placeholder={placeholder}
        />
    )
}

export default ParseNumberSmaller;
